import React from 'react';
import { BatchSummary } from '../hooks/useBatchList';
import '../styles/HospitalSimilarity.css';

interface BatchListProps {
  batches: BatchSummary[];
  loading: boolean;
  page: number;
  totalPages: number;
  onPageChange: (p: number) => void;
  onSelect: (batch: BatchSummary) => void;
}

const BatchList: React.FC<BatchListProps> = ({
  batches, loading, page, totalPages, onPageChange, onSelect
}) => {
  if (loading) {
    return <div className="no-data-message">Loading batches...</div>;
  }

  if (!batches.length) {
    return (
      <div className="no-data-message">
        No scrape batches found. Run a scraper first, then trigger format addresses.
      </div>
    );
  }

  return (
    <div className="batch-list-wrap">
      <table className="batch-table">
        <thead>
          <tr>
            <th>Insurance</th>
            <th>Source</th>
            <th>Date</th>
            <th className="num">Total</th>
            <th className="num">Matched</th>
            <th className="num">Doubtful</th>
            <th className="num">New</th>
            <th className="num">Rejected</th>
            <th className="num">Pending</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {batches.map((b) => (
            <tr
              key={b.jobId}
              className={b.pending > 0 ? 'batch-row batch-row--pending' : 'batch-row batch-row--done'}
            >
              <td className="batch-insurance">{b.insurance}</td>
              <td className="batch-source">{b.source}</td>
              <td className="batch-date">{new Date(b.createdAt).toLocaleDateString()}</td>
              <td className="num">{b.total}</td>
              <td className="num batch-matched">{b.matched}</td>
              <td className="num batch-doubtful">{b.doubtful}</td>
              <td className="num batch-new">{b.new_hospital}</td>
              <td className="num batch-rejected">{b.rejected}</td>
              <td className="num">
                {b.pending > 0
                  ? <span className="batch-pending-badge">{b.pending} pending</span>
                  : <span className="batch-done-badge">Done</span>
                }
              </td>
              <td>
                <button
                  className="btn-pagination batch-review-btn"
                  onClick={() => onSelect(b)}
                >
                  Review
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="pagination" style={{ marginTop: 12 }}>
          <button
            className="btn-pagination"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            « Previous
          </button>
          <span className="page-info">Page {page} of {totalPages}</span>
          <button
            className="btn-pagination"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Next »
          </button>
        </div>
      )}
    </div>
  );
};

export default BatchList;
